import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "../../icon";
import { theme } from "../../theme";
// TODO(drop): probably can be dropped as it's not used
export const IconRenderer = ({ name, color }) => (_jsx(Icon, { name: name, color: color }));
IconRenderer.defaultProps = {
    color: theme.color.primary,
};
